import { recordAnswer } from "@/lib/scheduler";
import type { PresentedType } from "@/lib/scheduler";
import { NextRequest, NextResponse } from "next/server";

export async function POST(request: NextRequest) {
  try {
    const body = await request.json();
    const { userId, problemId, sessionId, userInput, responseMs, presentedType } = body;

    if (!userId || !problemId || !sessionId || userInput === undefined || !responseMs) {
      return NextResponse.json(
        { error: "Missing required fields: userId, problemId, sessionId, userInput, responseMs" },
        { status: 400 }
      );
    }

    const validTypes: PresentedType[] = ["easy", "hard", "random", "retry"];
    const type: PresentedType = validTypes.includes(presentedType) ? presentedType : "hard";

    const result = await recordAnswer({
      userId,
      problemId,
      sessionId,
      userInput: String(userInput),
      responseMs: Number(responseMs),
      presentedType: type,
    });

    return NextResponse.json(result);
  } catch (error) {
    console.error("Error recording answer:", error);
    return NextResponse.json(
      { error: error instanceof Error ? error.message : "Failed to record answer" },
      { status: 500 }
    );
  }
}
